module.exports = __webpack_public_path__ + "static/img/2_2.ffda0b89.jpg";